import { Injectable } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
 
@Injectable({
  providedIn: 'root'
})
export class ConfirmationDialogService {
  private modalRef?: NgbModalRef;
 
  constructor(private modalService: NgbModal) { }
 
  public confirm(
    title: string,
    message: string,
    btnOkText: string = 'OK',
    centered:boolean,
    backdrop:boolean,
    custom_class?:string ,
    btnCancelText: string = 'Cancel',
    dialogSize: 'sm'|'lg' = 'lg'): Promise<boolean> {
    this.modalRef = this.modalService.open(ConfirmationDialogComponent, { size: dialogSize,backdrop:backdrop,windowClass: custom_class,centered:centered});
    this.modalRef.componentInstance.title = title;
    this.modalRef.componentInstance.message = message;
    this.modalRef.componentInstance.btnOkText = btnOkText;
    this.modalRef.componentInstance.btnCancelText = btnCancelText;
 
    return this.modalRef.result;
  }

  public closeDialog(result: boolean = true): void {
    if (this.modalRef) {
      this.modalRef.close(result); 
    }
  }
  
}
 